module.exports = __webpack_public_path__ + "img/passo2.48adec68.gif";